import React, { useMemo, useEffect, useState } from "react";
import styles from "./MisPostulaciones.module.scss";
import { connect } from "react-redux";
import { getPostulations } from "../../../store/actions/index";
import { Link, useHistory } from "react-router-dom";
import MainInfoItem from "../../MainInfoItem/MainInfoItem";
import { ReactComponent as Postulaciones } from "../../../assets/svg/misPostulaciones.svg";
import { ReactComponent as CloseIcon } from "../../../assets/svg/closeDropdown.svg";
import { ReactComponent as OpenIcon } from "../../../assets/svg/openDropdown.svg";
import { ReactComponent as SeeMore } from "../../../assets/svg/SeeMoreProjects.svg";
import InfoDropdown from "../InfoDropdown/InfoDropdown";
import { motion, AnimatePresence } from "framer-motion";
import defaultImage from "../../../assets/images/foto-bienvenida.jpg";
import queryString from "query-string";
import EmptyStateMyPostulations from "../../UI/EmptyState/EmptyStateMyPostulations";
import usePremiumCheck from "../../../hooks/usePremiumCheck"

const MisPostulaciones = (props) => {
  const history = useHistory();
  const premiumCheck = usePremiumCheck();
  const { viewmore } = queryString.parse(history.location?.search);
  const [isLoading, setIsLoading] = useState(true);
  const [dropdownOpen, setDropdownOpen] = useState(
    !!viewmore || props.fromPage
  );
  useEffect(() => {
    props.getPostulations(props.perfilAjeno);
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  }, [props.perfilAjeno]);
  // const handleDropDown = () =>{
  //   setDropdownOpen(!dropdownOpen);
  //   fireAnalytics('dsh_edit_aplications', {category: 'dashboard'});
  // }
  const dropdownChange = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const orderedPostulations = useMemo(() => {
    if (props.postulaciones && props.postulaciones.length) {
      let orderedPostulaciones = props.postulaciones.reverse();
      if (dropdownOpen && props.fromPage) {
        return orderedPostulaciones;
      } else {
        return [orderedPostulaciones[0]];
      }
    }
  }, [props.postulaciones, dropdownOpen]);

  const isLoaded = props.isLoaded;


  const handleOnClick = () => {
    if (premiumCheck) {
      history.push("/proyectosprivados");
    }
  };

  return (
    <AnimatePresence exitBeforeEnter>
      <motion.div
        initial={{ opacity: 0, y: 200 }}
        animate={{ opacity: 1, y: 0 }}
        className={`${styles.MisPostulaciones} ${
          !isLoaded ? styles.isLoaded : ""
        } ${props.fromPage ? styles.fromPage : ""}`}
      >
        <div className={styles.heading}>
          {isLoaded ? (
            <>
              <div className={styles.headingContainer}>
                {!props.fromPage &&
                  orderedPostulations &&
                  orderedPostulations.length > 0 && (
                    <Link
                      className={styles.seeAll}
                      to={{
                        pathname: "/postulaciones",
                        search: "?viewmore=true",
                      }}
                    >
                      {" "}
                      <SeeMore />
                      Ver más
                    </Link>
                  )}
              </div>
            </>
          ) : null}
        </div>
        {props.fromPage && (
        orderedPostulations && orderedPostulations.length > 0 ? (
          <>
            {orderedPostulations.map((postulacion, index) => {
              if (props.fromPage) {
                return (
                  <MainInfoItem
                    key={index}
                    item={postulacion}
                    isPostulation
                    defaultDropdownOpen={viewmore}
                    fromPage={props.fromPage}
                    perfilAjeno={props.perfilAjeno}
                    type="postulations"
                  />
                );
              } else {
                const image = postulacion.proyecto.proyecto_images && postulacion.proyecto.proyecto_images[0] ? 
                postulacion.proyecto.proyecto_images[0].image : defaultImage;
                return (
                  <InfoDropdown
                    key={index}
                    image={image}
                    description={postulacion.proyecto.description}
                    zone={postulacion.proyecto.zone}
                    endDate={postulacion.proyecto.endDate}
                    show={dropdownChange}
                    name={postulacion.proyecto.name}
                    history={"/postulaciones?viewmore=true"}
                  />
                );
              }
            })}
            <div
              className={styles.openDropdown}
              onClick={() => dropdownChange()}
            />
          </>
        ) : (
          <>
            <div className={styles.emptyState} onClick={premiumCheck(() => handleOnClick())}>
          <EmptyStateMyPostulations />           
              <h3>No hay postulaciones</h3>
              <h3>¿Querés postularte en un proyecto?</h3>
          </div>
          </>
        )
        )}
      </motion.div>
    </AnimatePresence>
  );
};

const mapStateToProps = (state) => {
  return {
    postulaciones: state.profile.postulations,
    isLoaded: state.general.isLoaded,
  };
};

export default connect(mapStateToProps, { getPostulations })(MisPostulaciones);
